import axios from '@/lib/AxApi';

export default {
  getNotifications(params, cb)
  {
    axios.get('/rest/Notifications/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/notifications.js